import { FeatherOrderStatus } from '@src/pages/Exchange/components/FeatherOrderFlow/FeatherOrderStatus'
import { FeatherBackendStatus } from '@src/types/feather'

/**
 * Maps backend Feather status values to frontend FeatherOrderStatus enum values
 * This is necessary because the backend sends status strings that don't directly map to our frontend enum
 *
 * @param backendStatus - The status value from the backend API response
 * @returns The corresponding frontend FeatherOrderStatus value
 */
export function mapBackendToFrontendStatus(backendStatus: FeatherBackendStatus): FeatherOrderStatus {
    const statusMap: Record<FeatherBackendStatus, FeatherOrderStatus> = {
        // Map directly using the same values
        [FeatherBackendStatus.UNKNOWN]: FeatherOrderStatus.UNKNOWN,
        [FeatherBackendStatus.ORDER_RECEIVED]: FeatherOrderStatus.ORDER_RECEIVED,
        [FeatherBackendStatus.PROCESSING]: FeatherOrderStatus.ORDER_PROCESSING,
        [FeatherBackendStatus.AWAITING_DEPOSIT]: FeatherOrderStatus.AWAITING_DEPOSIT,
        [FeatherBackendStatus.DEPOSIT_TIMEOUT]: FeatherOrderStatus.DEPOSIT_TIMEOUT,
        [FeatherBackendStatus.DEPOSIT_CONFIRMED]: FeatherOrderStatus.DEPOSIT_CONFIRMED,
        [FeatherBackendStatus.TRADING]: FeatherOrderStatus.TRADING,
        [FeatherBackendStatus.TRADE_FAILED]: FeatherOrderStatus.TRADE_FAILED,
        [FeatherBackendStatus.TRADED]: FeatherOrderStatus.TRADED,
        [FeatherBackendStatus.WITHDRAWING]: FeatherOrderStatus.WITHDRAWING,
        [FeatherBackendStatus.WITHDRAWAL_PENDING]: FeatherOrderStatus.WITHDRAWAL_PENDING,
        [FeatherBackendStatus.WITHDRAWAL_FAILED]: FeatherOrderStatus.WITHDRAWAL_FAILED,
        [FeatherBackendStatus.COMPLETED]: FeatherOrderStatus.COMPLETED,
        [FeatherBackendStatus.FAILED]: FeatherOrderStatus.FAILED,

        // PING is special, map to UNKNOWN
        [FeatherBackendStatus.PING]: FeatherOrderStatus.UNKNOWN,
    }

    return statusMap[backendStatus] || FeatherOrderStatus.UNKNOWN
}
